import { Injectable } from '@angular/core';
import { Location } from '@angular/common'
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private location: Location,
    private router: Router) {
  }

  goBack() {
    this.location.back();
  }

  goToNewCustomer(): Promise<boolean> {
    return this.router.navigate(['/customers/0']);
  }

  goToCustomer(id: string | number): Promise<boolean> {
    return this.router.navigate(['/customers', id]);
  }

  goToNewOrder(): Promise<boolean> {
    return this.router.navigate(['/orders/0']);
  }

  goToNewTeam(): Promise<boolean> {
    return this.router.navigate(['/teams/0']);
  }
}
